var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-link',{staticClass:"deck-banner-link",attrs:{"to":_vm.link,"tag":"div"}},[_c('div',{staticClass:"deck-banner-link--thumbnail",style:({background: _vm.bgColor})},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.label}}):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }